module.exports = __webpack_public_path__ + "media/images/icons/gf-arrow_right-sharp-38dc7c334eb508bed442876050b2ca5e.svg";